const certificationSuccess = (state, certification) => {
  Object.assign(state, { ...certification })
}

const certificationFailure = state => {
  Object.assign(state, {
    token: undefined,
    expiration: undefined
  })
}

export default {
  certificationSuccess,
  certificationFailure
}
